import axios from 'axios';
import {
  loginreq,
  wjldc,
  req
} from './axiosFun';

// 登录接口
export const login = (params) => {
  return loginreq("post", "https://a.maidanyun.com/adminapi/sys/login", params)
};
// 获取用户菜单
export const menu = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/getUserMenuCascade", params)
};
// 退出接口
export const loginout = () => {
  return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data)
};

/**
 * 用户管理
 **/

export const orderType = (params) => {
  return req("get", "https://a.maidanyun.com/adminapi/order/getTypeEnum", params)
};

/**
 * 用户权限管理
 **/
// 用户列表
export const getUserListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/getUserListPage", params)
};
//角色列表
export const getRoleListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/getRoleListPage", params)
};
//新建账号
export const addSysUser = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/addSysUser", params)
};
//更新账号信息
export const updateUser = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/updateSysUser", params)
};
//所有菜单列表
export const getAllMenu = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/getAllMenu", params)
};
//角色权限列表
export const yhRoleAuthArr = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/getRoleAuthArr", params)
};
//修改角色权限
export const assignRolePermissions = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/assignRolePermissions", params)
};
//添加角色
export const addYhRole = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sys/addRole", params)
};


export const investorCompany = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/investorCompany", params)
};

export const orderStaticsPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/order/orderStaticsPage", params)
};
/**
 * 渠道管理
 **/
export const getChannelList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/getChannelList", params)
};

export const getChannelGroupList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/getChannelGroupList", params)
};
export const delChannelGroup = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/delChannelGroup", params)
};
export const groupJoinChannel = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/groupJoinChannel", params)
};
export const getChannelMchListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/getChannelMchListPage", params)
};
export const addChannel = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/addChannel", params)
};
export const updateChannel = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/channel/updateChannel", params)
};
// export const getChannelMchListPage = (params) => {
// 	return req("post", "https://a.maidanyun.com/adminapi/channel/getChannelMchListPage", params)
// };
//消息

export const getMessageListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/message/getMessageListPage", params)
};
export const getPushMessageListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/message/getPushMessageListPage", params)
};
export const pushChannelMsg = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/message/pushChannelMsg", params)
};


//城市
export const getCityList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getCityByList", params)
};
//区域
export const getAreaList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getAreaList", params)
};




/**
 * 商家
 **/
// 商家管理-获取商家列表

export const getMerchantListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMerchantListPage", params)
};



//添加商家
export const addMerchant = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/addMch", params)
};
//店员列表
export const getMerchantMemberList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMerchantMemberList", params)
};

//城市
export const getBankBranchList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sysBank/getBankBranchList", params)
};
export const getBankCode = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sysBank/getBankCode", params)
};
export const getCityPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sysBank/getCityPage", params)
};
export const getProvincePage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/sysBank/getProvincePage", params)
};




//商家详情
export const merchantDetail = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMerchantInfo", params)
};




//修改银行卡信息
export const getLogPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getLogPage",
    params)
};



//修改银行卡信息
export const updateMerchantBankOrAmount = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tMerchant/updateMerchantBankOrAmount",
    params)
};

//审核
export const merchantState = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/merchantState", params)
};
//储值
export const merchantRecharge = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/merchantRecharge", params)
};
//品牌列表
export const getTMerchantGroupListPage = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tMerchant/getTMerchantGroupListPage",
    params)
};
export const getMchGroupListPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMchGroupListPage", params)
};
//添加品牌
export const addMerchantGroup = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/addMerchantGroup", params)
};



//修改品牌基本信息
export const updateMerchantGroup = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/updateGroup", params)
};
export const updateGroupBank = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/updateBank", params)
};



//商家品牌详情
export const getMerchantGroupDetail = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMchGroupInfo", params)
};
export const getGroupUserList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getGroupUserList", params)
};
//重新储值
export const againRecharge = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/againRecharge", params)
};
//类型列表
export const getMerchantTypeList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMerchantTypeList", params)
};




//修改商家基础数据
export const updateMerchantInfo = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/updateMch", params)
};







//区域
export const getAreaPage = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tMerchant/getAreaPage", params)
};
//商圈
export const getBusinessAreaPage = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tMerchant/getBusinessAreaPage", params)
};
//修改品牌储值信息
export const updateGroupDiscount = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/updateAmount", params)
};
export const create3 = (params) => {
  return req("post", 'https://wxapi.qicanhui.com/frontapi/enterprise/qrcode/create3', params)
};
export const bustList = (params) => {
  return req("post", 'https://wxapi.qicanhui.com/frontapi/enterprise/qrcode/create3', params)
};


export const synMerchantYxf3 = (params) => {
  return req("post", 'http://47.93.38.127:8388/yihai-business-console/tMerchant/synMerchantYxf', params)
};
export const getMchInfoEmpty = (params) => {
  return req("post", 'http://47.93.38.127:8388/yihai-business-console/tMerchant/getMchInfoEmpty', params)
};


/**
 * 订单
 **/
// 订单管理-获取商家列表
export const OrderList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/order/getOrderListPage", params)
};
// 订单管理-上传发票
export const uploadInvoice = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tEnterprise/uploadInvoice", params)
};
//订单管理-企业充值
export const getEnterprisePayListPage = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tEnterprise/getEnterprisePayListPage",
    params)
};
//订单管理-商家储值列表
export const getMerchantTransFlowPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/transFlow/getTransFlowListPage",
    params)
};

export const confirm = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/orderRefund/confirm",params)
};
export const getInvestorProfitPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getInvestorProfitPage", params)
};
export const createPartnershipDate = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/createPartnershipDate", params)
};


export const getGroupManageUserList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getGroupManageUserList", params)
};
export const createGroupManageUser = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/createGroupManageUser", params)
};
export const getMerchantListPag = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getMerchantListPage", params)
};
export const getCityInfoList = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/mch/getCityByList", params)
};


export const b2corderlist = (params) => {
  return req("post", "https://a.maidanyun.com/b2c/b2c/manage/maidanyun/order/list", params)
};
export const b2csupplierlist = (params) => {
  return req("post", "https://a.maidanyun.com/b2c/b2c/manage/maidanyun/supplier/list", params)
};
export const b2cgoodssearch = (params) => {
  return wjldc("post", "https://a.maidanyun.com/b2c/b2c/manage/maidanyun/order/export", params)
};
export const b2cordersupplierOrder = (params) => {
  return req("post", "https://a.maidanyun.com/b2c/b2c/manage/maidanyun/order/supplierOrder", params)
};
export const b2cgoodslist = (params) => {
  return req("post", "https://a.maidanyun.com/b2c/b2c/manage/maidanyun/goods/search", params)
};
export const b2cordersupplierSubOrder = (params) => {
  return req("post", "https://a.maidanyun.com/b2c/b2c/manage/maidanyun/order/supplierSubOrder", params)
};











export const byUserIdListqy = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tEnterprise/getEnt/orderPage", params)
};




export const updateChannelGroup = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/channel/updateChannelGroup", params)
};
export const getChannelGroupListPage = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/channel/getChannelGroupListPage", params)
};
export const channelGroupList = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/channel/channelGroupList", params)
};

export const getChannelListPage = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/channel/getChannelListPage", params)
};
export const getOrderRefundPage = (params) => {
  return req("post", "https://a.maidanyun.com/adminapi/orderRefund/getRefundListPage", params)
};
export const updateOrderRefundState = (params) => {
  return req("post", "http://47.93.38.127:8388/yihai-business-console/tEnterprise/updateOrderRefundState", params)
};



// WEBPACK FOOTER //
// ./src/api/userMG.js